import { GeneralIdentityApi, SystemRoles } from 'api/general-identity';
import { autoinject } from 'aurelia-framework';
import { UserDetail } from 'model/business-base';
import { ServiceBase } from 'support/base_classes/service-base';

@autoinject
export class IdentityService extends ServiceBase {
  user: UserDetail = null;
  roles: SystemRoles = null;

  constructor(private api: GeneralIdentityApi) {
    super();
  }

  protected async initializeService() {
    await this.reload();
  }

  async reload() {
    const identity = await this.api.getSessionIdentity();
    this.user = identity.user;
    this.roles = identity.roles;
  }
}
